import { QueryClient } from '@tanstack/react-query';
import { APIAuthenticationError, APIError } from '@/api/error';
import { notify } from '@/lib/feedback';

function reportError(error: unknown) {
  // 登录失效由认证流程统一处理，这里保持静默
  if (error instanceof APIAuthenticationError) return;
  const msg =
    error instanceof APIError ? error.message : (error as Error)?.message;
  notify.error(msg || '操作失败');
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof APIAuthenticationError) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      onError: reportError,
    },
  },
});
